// Modal.jsx
import React from "react";

const Modal = ({ isOpen, onClose, title, children,width = "max-w-md" }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className={`bg-white rounded-md  shadow-lg w-full ${width} p-6 relative animate-fade-in`}>
        {/* Close Button */}
        {/* <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
        >
          &times;
        </button> */}

        {/* Title */}
        {title && <h2 className="text-xl font-semibold mb-4">{title}</h2>}

        {/* Content */}
        <div>{children}</div>

        {/* Footer */}

         {/* <>
            <button
              onClick={() => setIsModalOpen(false)}
              className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                // Do something
                setIsModalOpen(false);
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Confirm
            </button>
          </> */}
     
      </div>
    </div>
  );
};

export default Modal;
